import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface PartnerAccessGrant {
  partner_name: string;
  partner_email: string;
  since: string;
  /** The agency created this account. */
  created_account: boolean;
}

export interface PartnerAccessRequest {
  id: number;
  partner_name: string;
  partner_email: string;
  requested_at: string;
}

export interface PartnerAction {
  at: string;
  partner_name: string;
  /** e.g. "Gutscheinprodukte: geändert" */
  description: string;
}

/** Settings → Agenturzugriff. */
export interface PartnerAccessOverview {
  current: PartnerAccessGrant | null;
  requests: PartnerAccessRequest[];
  /** Newest first. */
  actions: PartnerAction[];
}

/**
 * The customer's side of agency access: who works in the account, open requests,
 * what the agency changed. Owner-only: an agency gets 403 here.
 */
@Injectable({ providedIn: 'root' })
export class PartnerAccessService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = environment.apiUrl;

  overview(): Observable<PartnerAccessOverview> {
    return this.http.get<PartnerAccessOverview>(`${this.apiUrl}/company/partner-access`);
  }

  answer(requestId: number, answer: 'approve' | 'reject'): Observable<PartnerAccessOverview> {
    return this.http.post<PartnerAccessOverview>(
      `${this.apiUrl}/company/partner-access/requests/${requestId}/${answer}`,
      {},
    );
  }

  revoke(): Observable<PartnerAccessOverview> {
    return this.http.post<PartnerAccessOverview>(
      `${this.apiUrl}/company/partner-access/revoke`,
      {},
    );
  }
}
